<template>
  <div class="physioCategory" v-loading="loading">
    <div class="left">
      <div class="left_header">大类列表</div>
      <div class="left_list" :style="`height: calc(100% - 40px - ${['', '0', 0].includes(deptId) ? '32px' : '0px'});`">
        <div v-for="firstCategory in firstCategoryList" :key="firstCategory.id" :class="{ left_item: true, active: firstCategory.id === firstCategoryActiveId}" @click="firstCategoryOn(firstCategory.id)">
          <div class="left_item_name">{{ firstCategory.physioLabel }}</div>
          <div v-if="['', '0', 0].includes(deptId)" class="left_item_operate">
            <span class="el-icon-edit-outline left_item_operate_btn" @click.stop="editFirstCategory(firstCategory.id)"></span>
            <span class="el-icon-delete left_item_operate_btn" @click.stop="deleteFirstCategory(firstCategory.id)"></span>
          </div>
        </div>
      </div>
      <div v-if="['', '0', 0].includes(deptId)" class="left_footer" @click="editFirstCategory()">
        <span class="el-icon-plus left_footer_icon"></span>
        <span class="left_footer_text">新增大类</span>
      </div>
    </div>
    <div class="right" v-show="firstCategoryActiveId">
      <div class="right_header">
        <div class="right_header_title">
          <span class="right_header_title_text">小类列表</span>
        </div>
        <div class="right_header_operate">
          <el-button v-if="['', '0', 0].includes(deptId)" type="primary" icon="el-icon-plus" @click="editSecondCategory()">新增小类</el-button>
        </div>
      </div>
      <div class="right_table">
        <el-table
          height="100%"
          :data="secondCategoryList">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="小类名称" prop="physioLabel" min-width="220"></el-table-column>
          <el-table-column label="创建时间" prop="createTime" min-width="200">
            <template slot-scope="scope">
              {{ new Date(scope.row.createTime).Format('yyyy-MM-dd hh:mm:ss') }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" fixed="right">
            <template slot-scope="scope">
              <el-button v-if="['', '0', 0].includes(deptId)" type="primary" icon="el-icon-edit" @click="editSecondCategory(scope.row.id)">编辑</el-button>
              <el-button v-if="['', '0', 0].includes(deptId)" type="danger" icon="el-icon-delete" @click="deleteSecondCategory(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :title="`${firstCategoryMap.form.categoryId ? '编辑' : '新建'}大类`"
      :visible.sync="firstCategoryMap.visible"
      width="450px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="firstCategoryDialogClose">
      <div class="dialog_content" v-loading="firstCategoryMap.loading">
        <el-form ref="firstCategoryForm" class="dialog_form" :model="firstCategoryMap.form" :rules="firstCategoryMap.rules" label-width="100px">
          <el-form-item label="大类名称：" prop="physioLabel">
            <el-input class="dialog_form_input" v-model.trim="firstCategoryMap.form.physioLabel" maxlength="50" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="firstCategoryDialogClose">取 消</el-button>
        <el-button type="primary" :loading="firstCategoryMap.loading" @click="firstCategoryDialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="`${secondCategoryMap.form.categoryId ? '编辑' : '新建'}小类`"
      :visible.sync="secondCategoryMap.visible"
      width="450px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      :before-close="secondCategoryDialogClose">
      <div class="dialog_content" v-loading="secondCategoryMap.loading">
        <el-form ref="secondCategoryForm" class="dialog_form" :model="secondCategoryMap.form" :rules="secondCategoryMap.rules" label-width="100px">
          <el-form-item label="所属大类：" prop="parentId">
            <el-select class="dialog_form_input" v-model="secondCategoryMap.form.parentId" placeholder="请选择" disabled>
              <el-option
                v-for="item in firstCategoryList"
                :key="item.id"
                :label="item.physioLabel"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小类名称：" prop="physioLabel">
            <el-input class="dialog_form_input" v-model.trim="secondCategoryMap.form.physioLabel" maxlength="50" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button @click="secondCategoryDialogClose">取 消</el-button>
        <el-button type="primary" :loading="secondCategoryMap.loading" @click="secondCategoryDialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getPhysioCategoryList,
    getPhysioCategoryDetail,
    postPhysioCategory,
    putPhysioCategory,
    deletePhysioCategory
  } from '@/api/physio'

  export default {
    name: "physioCategory",
    data () {
      return {
        deptId: sessionStorage.getItem('deptId'),
        loading: false,
        firstCategoryActiveId: '',
        firstCategoryList: [],
        secondCategoryList: [],
        firstCategoryMap: {
          visible: false,
          loading: false,
          rules: {
            physioLabel: [{ required: true, message: '请输入大类名称', trigger: 'blur' }]
          },
          form: {
            categoryId: '',
            physioLabel: ''
          }
        },
        secondCategoryMap: {
          visible: false,
          loading: false,
          rules: {
            parentId: [{ required: true, message: '请选择所属大类', trigger: 'change' }],
            physioLabel: [{ required: true, message: '请输入小类名称', trigger: 'blur' }]
          },
          form: {
            parentId: '',
            categoryId: '',
            physioLabel: ''
          }
        }
      }
    },
    async created () {
      await this.getFirstCategory()
      if (this.firstCategoryList.length > 0) {
        this.firstCategoryOn(this.firstCategoryList[0].id)
      }
    },
    methods: {
      async getFirstCategory () {
        this.loading = true
        const res = await getPhysioCategoryList()
        this.loading = false
        if (res.code === 200) {
          this.firstCategoryList = res.data.filter(v => v.level === 1)
        }
      },
      async getSecondCategory () {
        this.loading = true
        const res = await getPhysioCategoryList({ categoryId: this.firstCategoryActiveId })
        this.loading = false
        if (res.code === 200) {
          this.secondCategoryList = res.data || []
        }
      },
      firstCategoryOn (id) {
        this.firstCategoryActiveId = id
        this.getSecondCategory()
      },
      async editFirstCategory (id = '') {
        this.firstCategoryMap.visible = true
        if (id) {
          this.firstCategoryMap.loading = false
          const res = await getPhysioCategoryDetail({ categoryId: id })
          this.firstCategoryMap.loading = false
          if (res.code === 200) {
            this.firstCategoryMap.form.categoryId = id
            this.firstCategoryMap.form.physioLabel = res.data.physioLabel
          }
        }
      },
      deleteFirstCategory (id = '') {
        if (id) {
          this.$confirm('确认删除该分类？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(async () => {
            const res = await deletePhysioCategory({ categoryId: id  })
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.getFirstCategory()
            }
          }).catch(() => {})
        }
      },
      firstCategoryDialogClose () {
        this.firstCategoryMap.visible = false
        this.firstCategoryMap.form.categoryId = ''
        this.firstCategoryMap.form.physioLabel = ''
      },
      firstCategoryDialogSubmit () {
        this.$refs['firstCategoryForm'].validate(async valid => {
          if (valid) {
            let res = null
            this.firstCategoryMap.loading = true
            if (['', null, undefined].includes(this.firstCategoryMap.form.categoryId)) {
              res = await postPhysioCategory(this.firstCategoryMap.form)
            } else {
              res = await putPhysioCategory(this.firstCategoryMap.form)
            }
            this.firstCategoryMap.loading = false
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.firstCategoryDialogClose()
              this.getFirstCategory()
            }
          }
        })
      },
      async editSecondCategory (id) {
        this.secondCategoryMap.visible = true
        if (id) {
          this.secondCategoryMap.loading = false
          const res = await getPhysioCategoryDetail({ categoryId: id })
          this.secondCategoryMap.loading = false
          if (res.code === 200) {
            this.secondCategoryMap.form.categoryId = id
            this.secondCategoryMap.form.parentId = res.data.parentId
            this.secondCategoryMap.form.physioLabel = res.data.physioLabel
          }
        } else {
          this.secondCategoryMap.form.parentId = this.firstCategoryActiveId
        }
      },
      deleteSecondCategory (id) {
        if (id) {
          this.$confirm('确认删除该分类？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(async () => {
            const res = await deletePhysioCategory({ categoryId: id  })
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.getSecondCategory()
            }
          }).catch(() => {})
        }
      },
      secondCategoryDialogClose () {
        this.secondCategoryMap.visible = false
        this.secondCategoryMap.form.parentId = ''
        this.secondCategoryMap.form.categoryId = ''
        this.secondCategoryMap.form.physioLabel = ''
      },
      secondCategoryDialogSubmit () {
        this.$refs['secondCategoryForm'].validate(async valid => {
          if (valid) {
            let res = null
            this.secondCategoryMap.loading = true
            if (['', null, undefined].includes(this.secondCategoryMap.form.categoryId)) {
              res = await postPhysioCategory(this.secondCategoryMap.form)
            } else {
              res = await putPhysioCategory(this.secondCategoryMap.form)
            }
            this.secondCategoryMap.loading = false
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.secondCategoryDialogClose()
              this.getSecondCategory()
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .physioCategory {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 1px solid #E0E0E0;
  }

  .left {
    flex-shrink: 0;
    width: 214px;
    height: 100%;
    border-right: 1px solid #E0E0E0;
  }

  .left_header {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    background-color: #F0F1F3;
    border-bottom: 1px solid #E0E0E0;
  }

  .left_list {
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .left_item {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 36px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #E0E0E0;
    cursor: pointer;
  }
  
  .left_item.active {
    background-color: #E8F4FF;
  }

  .left_item_name {
    width: 140px;
    font-size: 14px;
    color: #000000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .left_item.active .left_item_name {
    color: #1890FF;
  }

  .left_item_operate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .left_item_operate_btn {
    font-size: 14px;
    color: #667182;
  }

  .left_item_operate_btn+.left_item_operate_btn {
    margin: 0 0 0 6px;
  }

  .left_footer {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    border-top: 1px solid #E0E0E0;
    cursor: pointer;
  }

  .left_footer_icon {
    font-size: 14px;
    color: #1F2329;
  }

  .left_footer_text {
    margin: 0 0 0 4px;
    font-size: 14px;
    color: #1F2329;
  }

  .right {
    box-sizing: border-box;
    flex-grow: 1;
    padding: 16px 20px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .right_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 32px;
  }

  .right_header_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .right_header_title::before {
    content: '';
    display: block;
    width: 3px;
    height: 16px;
    background-color: #1890FF;
    border-radius: 8px;
  }

  .right_header_title_text {
    margin: 0 0 0 8px;
    font-weight: bold;
    font-size: 16px;
    color: #1F2329;
  }

  .right_header_operate {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .right_table {
    margin: 16px 0 0 0;
    width: 100%;
    height: calc(100% - 32px - 16px);
  }

  .physioCategory /deep/ .el-dialog__header {
    padding: 12px 24px;
    border-bottom: 1px solid #E0E0E0 !important;
  }

  .physioCategory /deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .physioCategory /deep/ .el-dialog__headerbtn {
    top: 16px;
    right: 18px;
    height: 16px;
  }

  .physioCategory /deep/ .el-dialog__body {
    padding: 0;
  }

  .physioCategory /deep/ .el-dialog__footer {
    padding: 12px 16px;
  }

  .dialog_content {
    padding: 20px 20px 0;
  }

  .dialog_form {
    overflow: hidden;
  }

  .dialog_form /deep/ .el-form-item__label {
    line-height: 32px;
    color: #333333;
  }

  .dialog_form /deep/ .el-form-item__content {
    line-height: 32px;
  }

  .dialog_form_input {
    width: 100%;
  }
</style>